import { render, staticRenderFns } from "./RuntimeAccess.vue?vue&type=template&id=6019b583&scoped=true"
import script from "./RuntimeAccess.vue?vue&type=script&lang=js"
export * from "./RuntimeAccess.vue?vue&type=script&lang=js"
import style0 from "./RuntimeAccess.vue?vue&type=style&index=0&id=6019b583&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6019b583",
  null
  
)

export default component.exports